// env.ts — Typed environment variable access

/** Base URLs for module data endpoints. Fall back to empty string for graceful degradation. */
export const env = {
  kuroboard: {
    dataBaseUrl: import.meta.env.VITE_KUROBOARD_DATA_BASE_URL ?? '',
  },
  kurotrader: {
    dataBaseUrl: import.meta.env.VITE_KUROTRADER_DATA_BASE_URL ?? '',
  },
  gokuHealth: {
    dataBaseUrl: import.meta.env.VITE_GOKU_HEALTH_DATA_BASE_URL ?? '',
  },
  kuroSite: {
    dataBaseUrl: import.meta.env.VITE_KURO_SITE_DATA_BASE_URL ?? '',
  },
  kuro: {
    dataBaseUrl: import.meta.env.VITE_KURO_DATA_BASE_URL || 'https://kuro-claw.github.io/kuro-data/kuro',
  },
  platformTitle: import.meta.env.VITE_PLATFORM_TITLE ?? 'Kuro',
  defaultRefreshInterval: Number(import.meta.env.VITE_DEFAULT_REFRESH_INTERVAL ?? 60_000),
  enableDevTools: import.meta.env.VITE_ENABLE_DEV_TOOLS === 'true',
} as const

/** Build a full endpoint URL for a module */
export function buildEndpointUrl(baseUrl: string, path: string): string {
  if (!baseUrl) return path
  const base = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl
  const p = path.startsWith('/') ? path : `/${path}`
  return `${base}${p}`
}
